import { config } from '@/config';
export const EstadoService = {
    async getCiudadById(id) {
        const response = await fetch(`${config.API_URL}/api/Estado/${id}`, {
            method: 'GET',
        });
        if (!response.ok) {
            throw new Error(`Error al obtener la ciudad con id ${id}`);
        }
        const data = await response.json();
        return data;
    },
    async getAllCiudades() {
        const response = await fetch(`${config.API_URL}/api/Estado`, {
            method: 'GET',
        });
        if (!response.ok) {
            throw new Error('Error al obtener todas las ciudades');
        }
        const result = await response.json();
        // Verifica que `datos` existe y es un array
        if (!result.datos || !Array.isArray(result.datos)) {
            console.error('Se esperaba un array de ciudades en la propiedad "datos" pero se recibió:', result);
            return []; // Devuelve un array vacío en caso de error
        }
        return result.datos;
    },
};
